import { Injectable } from "@angular/core";
import { VisualizationEntity } from "@arch/domain/entity";

export interface SortOption {
    value: string;
    label: string;
}

@Injectable({
    providedIn: "root"
})
export class VisualizationSortService {
    public readonly sortOptions: SortOption[] = [
        { value: "Relevância", label: "Relevância" },
        { value: "Com comentário", label: "Com comentário" },
        { value: "Sem comentário", label: "Sem comentário" },
        { value: "Com reações", label: "Com reações" },
        { value: "Sem reação", label: "Sem reação" },
        { value: "Com notas", label: "Com notas" },
        { value: "Alfabéticas A-Z", label: "Alfabéticas A-Z" },
        { value: "Alfabéticas Z-A", label: "Alfabéticas Z-A" }
    ];

    public sortVisualizations(
        visualizations: VisualizationEntity[],
        sortOrder: string
    ): VisualizationEntity[] {
        if (!visualizations || visualizations.length === 0) {
            return [];
        }

        const sortedVisualizations = [...visualizations];

        switch (sortOrder) {
            case "Alfabéticas A-Z":
                return sortedVisualizations.sort((a, b) => {
                    const nameA = a.props?.name || "";
                    const nameB = b.props?.name || "";
                    return nameA.localeCompare(nameB);
                });

            case "Alfabéticas Z-A":
                return sortedVisualizations.sort((a, b) => {
                    const nameA = a.props?.name || "";
                    const nameB = b.props?.name || "";
                    return nameB.localeCompare(nameA);
                });

            case "Com comentário":
                return sortedVisualizations.sort((a, b) => {
                    const aHasComments = a.posts && a.posts.length > 0;
                    const bHasComments = b.posts && b.posts.length > 0;

                    if (aHasComments && !bHasComments) return -1;
                    if (!aHasComments && bHasComments) return 1;
                    return 0;
                });

            case "Sem comentário":
                return sortedVisualizations.sort((a, b) => {
                    const aHasComments = a.posts && a.posts.length > 0;
                    const bHasComments = b.posts && b.posts.length > 0;

                    if (!aHasComments && bHasComments) return -1;
                    if (aHasComments && !bHasComments) return 1;
                    return 0;
                });

            case "Com reações":
                return sortedVisualizations.sort((a, b) => {
                    const aHasReactions = a.postsLike && a.postsLike.length > 0;
                    const bHasReactions = b.postsLike && b.postsLike.length > 0;

                    if (aHasReactions && !bHasReactions) return -1;
                    if (!aHasReactions && bHasReactions) return 1;
                    return 0;
                });

            case "Sem reação":
                return sortedVisualizations.sort((a, b) => {
                    const aHasReactions = a.postsLike && a.postsLike.length > 0;
                    const bHasReactions = b.postsLike && b.postsLike.length > 0;

                    if (!aHasReactions && bHasReactions) return -1;
                    if (aHasReactions && !bHasReactions) return 1;
                    return 0;
                });

            case "Com notas":
                return sortedVisualizations.sort((a, b) => {
                    const aHasNotes = !!a.note;
                    const bHasNotes = !!b.note;

                    if (aHasNotes && !bHasNotes) return -1;
                    if (!aHasNotes && bHasNotes) return 1;
                    return 0;
                });

            case "Resultado bom":
            case "Resultado estável":
            case "Resultado ruim":
                return sortedVisualizations;
            default:
                return sortedVisualizations;
        }
    }
}
